export default "__VITE_ASSET__FDjsbBD$__"